// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Public_Sans_c2662c', '__Public_Sans_Fallback_c2662c', sans-serif","fontStyle":"normal"},"className":"__className_c2662c","variable":"__variable_c2662c"};